import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'
import story from "@/components/modules/stories/story/index.vue";

export default {
    name: 'podcast',
    props: {
        id : String,
        autoplay : Boolean,
        fromtime : Number
    },
    components : {
        story
    },
    data : function(){

        return {
            loading : false,
            error : null,
            podcast : null,
            f
        }

    },

    created : () => {

    },

    watch: {
        id : {
            immediate : true,
            handler : function(){
                this.destroy()
                this.create()
                this.load()
            }
        },
    },
    computed: mapState({
        auth : state => state.auth,
        ageCluster : function(){
            if(!this.podcast) return null

            return f.findCluster(this.podcast.age, f.deep(this.core, 'appInfo.snippity.settings.ageClusters') || [])
        },

        admin : function(){
            return this.core.user.checkFeatures(['admin'])
        },

        haslicense : function(){
            return this.core.user.checkFeatures(['podcasts'])
        },

        sharelink : function(){
            return 'https://' + this.core.domain + '/podcasts/' + this.id
        }
    }),

    methods : {
        destroy : function(){},
        create : function(){},
      

        load : function(){

            if(!this.id){
                this.error = '404'

                return
            }

            this.loading = true
            this.resloading = true
            
            var promise = this.core.api.podcasts.get(this.id)

            promise.then((podcast) => {
                this.podcast = podcast

                console.log('this.podcast', this.podcast)

            }).catch(e => {
                this.error = e
            }).finally(() => {
                this.loading = false
            })
        },

    },
}